export const Common = {
  colors: {
    primary: '#fcb25b',
    primary_light:'#ffe7da',
    primary_lighter: '#fff9f1',
    primary_dark:'#ffd29D',
    primary_darker: '#E6A153',
    purple: '#6e3bf8',
    brown: '#5a2f0f',
    brown_light: '#904309',
    brown_lighter:'#c96217'
  },
}